<template>
    <div class="loading" v-show="show">
        <div class="icon">
            <i class="el-icon-loading"></i>
        </div>
        <div class="tip">正在加载...</div>
    </div>
</template>

<script>

export default{
    name: 'Loading',
    props:{
        show: Boolean    
    }
}
</script>

<style lang="less" scoped>
    .loading{
        position: fixed;
        padding: 0.35rem 0.25rem;
        background: #f1f1f1;
        border-radius: 0.2rem;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-size: 0.4rem;
        z-index: 50;
        i{
            font-size: 0.8rem;    
        }
    }              
</style>   